// Film photo data - 67 photos ready to go!
// Add descriptions as you have time - empty for now

export const filmPhotos = [
    { src: "/images/film/000319920009.jpg", description: "" },
    { src: "/images/film/000319920022.jpg", description: "" },
    { src: "/images/film/000319930006.jpg", description: "" },
    { src: "/images/film/000319930008.jpg", description: "" },
    { src: "/images/film/000319930010.jpg", description: "" },
    { src: "/images/film/000319930011.jpg", description: "" },
    { src: "/images/film/000319930013.jpg", description: "" },
    { src: "/images/film/000319930015.jpg", description: "" },
    { src: "/images/film/000319930020.jpg", description: "" },
    { src: "/images/film/000319930032.jpg", description: "" },
    { src: "/images/film/000319930035.jpg", description: "" },
    { src: "/images/film/000319930037.jpg", description: "" },
    { src: "/images/film/000319930038.jpg", description: "" },
    { src: "/images/film/000319940006.jpg", description: "" },
    { src: "/images/film/000319940010.jpg", description: "" },
    { src: "/images/film/000319940011.jpg", description: "" },
    { src: "/images/film/000319940018.jpg", description: "" },
    { src: "/images/film/000319940020.jpg", description: "" },
    { src: "/images/film/000319940026.jpg", description: "" },
    { src: "/images/film/000319940030.jpg", description: "" },
    { src: "/images/film/000319940034.jpg", description: "" },
    { src: "/images/film/000319950029.jpg", description: "" },
    { src: "/images/film/000319960005.jpg", description: "" },
    { src: "/images/film/000319960007.jpg", description: "" },
    { src: "/images/film/000319960009.jpg", description: "" },
    { src: "/images/film/000319970001.jpg", description: "" },
    { src: "/images/film/000319970009.jpg", description: "" },
    { src: "/images/film/000347820001.jpg", description: "" },
    { src: "/images/film/000347820005.jpg", description: "" },
    { src: "/images/film/000347820008.jpg", description: "" },
    { src: "/images/film/000347820016.jpg", description: "" },
    { src: "/images/film/000347830002.jpg", description: "" },
    { src: "/images/film/000347830004.jpg", description: "" },
    { src: "/images/film/000347830008.jpg", description: "" },
    { src: "/images/film/000347830012.jpg", description: "" },
    { src: "/images/film/000347830015.jpg", description: "" },
    { src: "/images/film/000347830023.jpg", description: "" },
    { src: "/images/film/000347830025.jpg", description: "" },
    { src: "/images/film/000347840001.jpg", description: "" },
    { src: "/images/film/000347840003.jpg", description: "" },
    { src: "/images/film/000347840007.jpg", description: "" },
    { src: "/images/film/000347840008.jpg", description: "" },
    { src: "/images/film/000347840009.jpg", description: "" },
    { src: "/images/film/000347840011.jpg", description: "" },
    { src: "/images/film/000347840015.jpg", description: "" },
    { src: "/images/film/000347840016.jpg", description: "" },
    { src: "/images/film/000347850010.jpg", description: "" },
    { src: "/images/film/000347850013.jpg", description: "" },
    { src: "/images/film/000347850015.jpg", description: "" },
    { src: "/images/film/000347850020.jpg", description: "" },
    { src: "/images/film/000347850021.jpg", description: "" },
    { src: "/images/film/000347850022.jpg", description: "" },
    { src: "/images/film/000347860004.jpg", description: "" },
    { src: "/images/film/000347860007.jpg", description: "" },
    { src: "/images/film/000347860012.jpg", description: "" },
    { src: "/images/film/000347860017.jpg", description: "" },
    { src: "/images/film/000347860025.jpg", description: "" },
    { src: "/images/film/000555690002.jpg", description: "" },
    { src: "/images/film/000555690020.jpg", description: "" },
    { src: "/images/film/000555700014.jpg", description: "" },
    { src: "/images/film/000555700024.jpg", description: "" },
    { src: "/images/film/000555720014.jpg", description: "" },
    { src: "/images/film/000555720016.jpg", description: "" },
    { src: "/images/film/000555720018.jpg", description: "" },
    { src: "/images/film/000555720019.jpg", description: "" },
    { src: "/images/film/000555720029.jpg", description: "" },
    { src: "/images/film/000555720034.jpg", description: "" },
];
